import React, { useEffect, useRef, useState } from "react";
import { LiaDownloadSolid } from "react-icons/lia";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import dashboardTalent2 from "../../assets/images/dashboardTalent2.png";
import { Button, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";

import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import { User } from "lucide-react";
import Image from "../../components/Image";
import  LocationDot  from "../../assets/images/location.png";
import { useUser } from "../../context/UserContext";
import { useTranslation } from "react-i18next";

const USE_API = false;
const STATIC_DURATIONS = [
  { value: "1 Month", label: "1 Month" },
  { value: "3 Months", label: "3 Months" },
  { value: "6 Months", label: "6 Months" },
];
const STATIC_JOB_TYPES = [
  { value: "Full Time", label: "Full Time" },
  { value: "Part Time", label: "Part Time" },
  { value: "Contract", label: "Contract" },
];

const useFormOptions = () => {
  const [durationOptions, setDurationOptions] = useState([]);
  const [jobTypeOptions, setJobTypeOptions] = useState([]);

  useEffect(() => {
    if (USE_API) {
      (async () => {
        try {
          // Example endpoints, replace with your actual endpoints
          const durationRes = await ApiService.get("/company/getDurations");
          const jobTypeRes = await ApiService.get("/company/getJobTypes");
          setDurationOptions(
            Array.isArray(durationRes.data.data)
              ? durationRes.data.data.map((d) => ({
                  value: d.value,
                  label: d.label,
                }))
              : []
          );
          setJobTypeOptions(
            Array.isArray(jobTypeRes.data.data)
              ? jobTypeRes.data.data.map((j) => ({
                  value: j.value,
                  label: j.label,
                }))
              : []
          );
        } catch (err) {
          toast.error("Failed to load form options");
          setDurationOptions([]);
          setJobTypeOptions([]);
        }
      })();
    } else {
      setDurationOptions(STATIC_DURATIONS);
      setJobTypeOptions(STATIC_JOB_TYPES);
    }
  }, []);

  return { durationOptions, jobTypeOptions };
};

// Post form data to API or simulate
const postFormData = async (formData) => {
  if (USE_API) {
    const formPayload = new FormData();
    try {
      const res = await ApiService.post("/company/stepForm", formPayload); // Replace with actual endpoint
      if (res.data.status) {
        toast.success("Step data submitted successfully!");
        return true;
      } else {
        toast.error(res.data.message || "Failed to submit step data");
        return false;
      }
    } catch (err) {
      toast.error("Error submitting step data");
      return false;
    }
  } else {
    toast.success("Step data submitted! (static)");
    return true;
  }
};

// Request for quote API
const requestQuote = async (formData) => {
  if (USE_API) {
    const formPayload = new FormData();
    try {
      const res = await ApiService.post("/company/requestQuote", formPayload);
      if (res.data.status) {
        toast.success("Quote requested successfully!");
        return true;
      } else {
        toast.error(res.data.message || "Failed to request quote");
        return false;
      }
    } catch (err) {
      toast.error("Error submitting quote request");
      return false;
    }
  } else {
    toast.success("Quote requested successfully! (static)");
    return true;
  }
};

// View quote API
const viewQuote = async (formData) => {
  if (USE_API) {
    try {
      const res = await ApiService.get(
        `/company/viewQuote?projectId=${formData.projectId}`
      ); // Replace with actual param
      if (res.data.status) {
        toast.succeonViewQuotess("Quote loaded!");
        // You can handle the quote data here
        return res.data.data;
      } else {
        toast.error(res.data.message || "Failed to load quote");
        return null;
      }
    } catch (err) {
      toast.error("Error loading quote");
      return null;
    }
  } else {
    toast.success("Quote loaded! (static)");
    return { quote: "Sample quote data" };
  }
};


// Stepper Section (interactive)
const HorizontalStepper = ({ step, setStep }) => {
  const { t, i18n } = useTranslation();
  return(
  <div
    className="inter-font d-flex justify-content-center align-items-center mb-5"
    style={{ marginTop: 20 }}
  >
    {/* Step 1 */}
    <div className="inter-font d-flex align-items-center gap-2">
      <div
        onClick={() => step > 1 && setStep(1)}
        style={{
          width: 36,
          height: 36,
          borderRadius: "50%",
          background: step === 1 ? "#111" : "#fff",
          color: step === 1 ? "#fff" : "#111",
          border: step === 1 ? "2px solid #111" : "2px solid #E6E6E6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 600,
          fontSize: 18,
          cursor: step > 1 ? "pointer" : "default",
          transition: "all 0.2s",
        }}
      >
        1
      </div>
      <span
        onClick={() => step > 1 && setStep(1)}
        className="d-none d-md-inline"
        style={{
          fontWeight: step === 1 ? 600 : 400,
          color: step === 1 ? "#111" : "#B0B0B0",
          // marginLeft: 10,
          fontSize: 18,
          cursor: step > 1 ? "pointer" : "default",
        }}
      >
        {t("c_t_s1_setp1")}
      </span>
    </div>
    {/* Arrow 1 */}
    <span style={{ color: "#B0B0B0", fontSize: 28, margin: "0 24px" }}>
      &#8594;
    </span>
    {/* Step 2 */}
    <div className="inter-font d-flex align-items-center gap-2">
      <div
        onClick={() => step > 2 && setStep(2)}
        style={{
          width: 36,
          height: 36,
          borderRadius: "50%",
          background: step === 2 ? "#111" : "#fff",
          color: step === 2 ? "#fff" : "#111",
          border: step === 2 ? "2px solid #111" : "2px solid #E6E6E6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 600,
          fontSize: 18,
          cursor: step > 2 ? "pointer" : "default",
          transition: "all 0.2s",
        }}
      >
        2
      </div>
      <span
        onClick={() => step > 2 && setStep(2)}
        className="d-none d-md-inline"
        style={{
          fontWeight: step === 2 ? 600 : 400,
          color: step === 2 ? "#111" : "#B0B0B0",
          marginLeft: 10,
          fontSize: 18,
          cursor: step > 2 ? "pointer" : "default",
        }}
      >
        {t("c_t_s1_setp2")}
      </span>
    </div>
    {/* Arrow 2 */}
    <span style={{ color: "#B0B0B0", fontSize: 28, margin: "0 24px" }}>
      &#8594;
    </span>
    {/* Step 3 */}
    <div className="inter-font d-flex align-items-center gap-2">
      <div
        onClick={() => step > 3 && setStep(3)}
        style={{
          width: 36,
          height: 36,
          borderRadius: "50%",
          background: step === 3 ? "#111" : "#fff",
          color: step === 3 ? "#fff" : "#111",
          border: step === 3 ? "2px solid #111" : "2px solid #E6E6E6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 600,
          fontSize: 18,
          cursor: step > 3 ? "pointer" : "default",
          transition: "all 0.2s",
        }}
      >
        3
      </div>
      <span
        onClick={() => step > 3 && setStep(3)}
        className="d-none d-md-inline"
        style={{
          fontWeight: step === 3 ? 600 : 400,
          color: step === 3 ? "#111" : "#B0B0B0",
          marginLeft: 10,
          fontSize: 18,
          cursor: step > 3 ? "pointer" : "default",
        }}
      >
        {t("c_t_s1_setp3")}
      </span>
    </div>
  </div>
)};

const ProjectInfoScreen = ({
  formData,
  setFormData,
  errors = {},
  setErrors,
  onNext,
  durationOptions,
  jobTypeOptions,
  selectedTalents = [],
  selectedTalentData,
  setSelectedTalentsUpdatedData,
}) => {
  const [showCalendar, setShowCalendar] = useState(false);

  const formatDisplayDate = (date) => {
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (setErrors)
      setErrors((prev) => ({ ...prev, [e.target.name]: undefined }));
  };

  const handleDateChange = (newStartDate, newEndDate) => {
    setFormData({
      ...formData,
      startDate: newStartDate,
      endDate: newEndDate,
      dateSlot: `${formatDisplayDate(newStartDate)} - ${formatDisplayDate(
        newEndDate
      )}`,
    });
    if (setErrors) setErrors((prev) => ({ ...prev, dateSlot: undefined }));
  };

  const [data, setData] = useState(
    selectedTalentData.map((person) => ({
      ...person,
      title: "",
      description: "",
      job_type: "",
      hours: "",
      category: person.skill_id ? { 
      _id: person.skill_id._id, 
      title: person.skill_id.title,
      commission_rate: person.skill_id.commission_rate,
    } : { _id: "", title: "" },
      sub_skill: { _id: "", title: "" },
             availableSubSkills: person.sub_skill_ids ? person.sub_skill_ids.map(sub => ({
      value: sub._id,
      label: i18n.language === "ar" ? sub.title_ar || sub.title : sub.title
    })) : [],
      duration: "",
      start_date: null,
      end_date: null,
    }))
  );
console.log('data----', data)
  const [isLoadingCreateQuotes, setIsLoadingCreateQuotes] = useState(false);

  const [projectTitle, setProjectTitle] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const handleChange = (index, field, value) => {
    const newData = [...data];
    newData[index][field] = value;
    setData(newData);
  };


  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  const handleApply = (event, picker, index) => {
    const start = picker.startDate.format("YYYY-MM-DD");
    const end = picker.endDate.format("YYYY-MM-DD");
    setDateRange({ startDate: start, endDate: end });

    handleChange(index, "start_date", start);
    handleChange(index, "end_date", end);
    // onChange({ from: start, to: end });
  };


  const calculateDuration = (startStr, endStr) => {
    if (!startStr || !endStr) return "";
  
    const startDate = new Date(startStr);
    const endDate = new Date(endStr);
  
    // Calculate difference in milliseconds
    const diffTime = endDate - startDate;
  
    // Convert to days (inclusive of both start and end dates)
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
  
    return `${diffDays}`;
  };
  
  const handleCreateQuotes = async (data) => {
    try {
      setIsLoadingCreateQuotes(true);
      const res = await ApiService.request({
        method: "POST",
        url: `company/postProject`,
        data: { projects: data },
      });

      if (res.data.status) {
        // setCreateJobData(false);
        // await fetchJobData(1);
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.error("Edit Error:", err);
      toast.error("Failed to update job.");
    } finally {
      setIsLoadingCreateQuotes(false);
    }
  };

  // Handle sub-skill change
  const handleSubSkillChange = (selected, index) => {
    handleChange(index, "sub_skill", {
      _id: selected.value,
      title: selected.label,
    });
  };
  // Handle category change
 const handleCategoryChange = async (selected, index) => {
    // Update category
    handleChange(index, "category", {
      _id: selected.value,
      title: selected.label,
    });
    
    // Clear sub-skill when category changes
    handleChange(index, "sub_skill", { _id: "", title: "" });
    
  };


  const handleSaveAndProceed = () => {
    // Validate all fields before proceeding
    const newErrors = {
      projectTitle: !projectTitle.trim() ? `${t("t_d_text100")}` : "",
      projectInfo: !projectDescription.trim() ? `${t("t_d_text100")}` : "",
    };
  
    // Validate each talent's fields
    const talentErrors = data.map((person) => {
      const personErrors = {};
      if (!person.category || person.category.length === 0) {
        personErrors.category = `${t("t_d_text100")}`;
      }
       if (!person.sub_skill || !person.sub_skill._id) {
    personErrors.sub_skill = `${t("t_d_text100")}`;
  }
      if (!person.job_type) {
        personErrors.job_type = `${t("t_d_text100")}`;
      }
      if (!person.start_date || !person.end_date) {
        personErrors.dateSlot = `${t("t_d_text100")}`;
      }
      return personErrors;
    });
  
    // Check if any talent has errors
    const hasTalentErrors = talentErrors.some((error) => 
      Object.values(error).some((msg) => msg)
    );
  
    // Set all errors
    setErrors({
      ...newErrors,
      talentErrors,
    });
  
    // If any errors exist, stop execution
    if (Object.values(newErrors).some((msg) => msg) || hasTalentErrors) {
      return;
    }
  
    const mergedData = data.map((person) => ({
      ...person,
      title: projectTitle,
      description: projectDescription,
      job_type: person?.job_type,
      skill_id: person?.category?._id,
    category: {
      _id: person?.category?._id,
      title: person?.category?.title,
      commission_rate: person?.category?.commission_rate
    },
    sub_skill_id: person?.sub_skill?._id,
    sub_skill: {
      _id: person?.sub_skill?._id,
      title: person?.sub_skill?.title
    },
      duration: calculateDuration(person?.start_date, person?.end_date),
      start_date: person?.start_date,
      end_date: person?.end_date,
      talent_id: person?._id,
    }));
  
    console.log("Prepared data for review: ", mergedData);
    setSelectedTalentsUpdatedData(mergedData);
    onNext(); // Navigate to review page
  };

  const handleProceed = async () => {
    // Validate fields before proceeding
    if (!projectTitle.trim() || !projectDescription.trim()) {
      setErrors({
        projectTitle: !projectTitle.trim() ? "Project title is required" : "",
        projectInfo: !projectDescription.trim()
          ? "Project information is required"
          : "",
      });
      return; // Stop execution if validation fails
    }

    // If validation passes, proceed with the original logic
    try {
      const mergedData = data.map((person) => ({
        title: projectTitle,
        description: projectDescription,
        job_type: person?.job_type,
        duration: calculateDuration(person?.start_date, person?.end_date),
        start_date: person?.start_date,
        end_date: person?.end_date,
        talent_id: person?._id,
      }));

      const resData = await handleCreateQuotes(mergedData);

      if (resData?.status) {
        const mergedData = data.map((person) => ({
          ...person,
          title: projectTitle,
          description: projectDescription,
          job_type: person?.job_type,
          duration: calculateDuration(person?.start_date, person?.end_date),
          start_date: person?.start_date,
          end_date: person?.end_date,
          talent_id: person?._id,
        }));
        setSelectedTalentsUpdatedData(mergedData);
        onNext();
      }
    } catch (error) {
      console.error("Error in handleProceed:", error);
      // Handle any errors that might occur during the process
    }
  };
  const formatShortDate = (dateString) => {
    if (!dateString) return "";
  
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
  
    return `${day}-${month}-${year}`;
  };
  
 const { t, i18n } = useTranslation();
       const isRTL = i18n.language === 'ar';

  return (
    <div
      className="inter-font d-flex justify-content-center"
      style={{
        paddingTop: 30,
        paddingBottom: 40,
        boxSizing: "border-box",
      }}
    >
      <style>{`
        .single-calendar-picker .daterangepicker .drp-calendar.right {
          display: none !important;
        }
        .single-calendar-picker .daterangepicker {
          width: auto !important;
        }
        .single-calendar-picker .daterangepicker .drp-calendar.left {
          padding: 8px 4px;
        }
      `}</style>
      <div
        className="inter-font bg-white rounded-4 shadow p-4 position-relative"
        style={{  maxWidth: "100%" }}
      >
   

        <div className="inter-font mb-4" >
          <div style={{ color: "#B0B0B0", fontSize: 18, fontWeight: 500 }}>
            {t("new_text_43")}          
            </div>
        </div>
        {/* Form */}
        <form>
      

          <div className="inter-font mb-2">
          
            <Form.Group className="inter-font mb-3 inter-font fw-semibold">
              <Form.Label>
                  {t("t_d_text95")}  <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={projectTitle}
                placeholder={t("new_text_44")}
                onChange={(e) => setProjectTitle(e.target.value)}
              />
            </Form.Group>
            {errors.projectInfo && (
              <div style={{ color: "red", fontSize: 13, marginTop: 2 }}>
                {errors.projectInfo}
              </div>
            )}
          </div>
          <div className="inter-font mb-4">
            <label
              className="inter-font fw-semibold mb-2 inter-font"
              style={{ fontSize: 16 }}
            >
              {t("c_ff_text82")} {" "}
              <span className="text-danger">*</span>
            </label>
            <textarea
              className={`inter-font form-control inter-font ${
                errors.projectInfo ? "is-invalid" : ""
              }`}
              name="projectInfo"
              value={projectDescription}
              onChange={(e) => setProjectDescription(e.target.value)}
              // value={formData.projectInfo}
              // onChange={handleInputChange}
              style={{
                minHeight: 80,
                fontSize: 18,
                borderRadius: 10,
                borderColor: errors.projectInfo ? "#dc3545" : "#E6E6E6",
                marginBottom: 12,
              }}
              placeholder={t("new_text_45")}
            />
            {errors.projectInfo && (
              <div style={{ color: "red", fontSize: 13, marginTop: 2 }}>
                {errors.projectInfo}
              </div>
            )}
          </div>
   <div
  className="inter-font bg-white rounded-3 p-3 p-md-4 shadow"
  style={{ height: "auto" }}
>
  {data.map((person, index) => (
    <Row
      key={person._id}
      className="inter-font mb-4 inter-font"
      style={{
        borderBottom: "1px solid #eee",
        paddingBottom: "20px",
      }}
    >
      {/* Talent Info - Full width */}
      <Col xs={12} className="inter-font d-flex align-items-center mb-3 gap-3">
        <Image
          src={person?.picture}
          alt="logo"
          className="rounded-circle"
          style={{
            width: "50px",
            height: "50px",
            objectFit: "cover",
            border: "2px solid #ddd",
          }}
        />

        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <h5
            className="inter-font mb-1 fw-bold inter-font"
            style={{ fontSize: "16px" }}
          >
            {person.first_name} {person.last_name}
          </h5>
          
          {(person.nationality || person.country) && (
            <div
              className={`text-muted d-flex align-items-center ${isRTL ? 'flex-row-reverse justify-content-end ' : ''}`}
              style={{
                flexWrap: "nowrap",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <img
                src={LocationDot}
                alt="Location Icon"
                style={{
                  width: "15px",
                  height: "19px",
                  flexShrink: 0,
                  marginRight: "6px",
                }}
              />
              <span
                className="d-flex align-items-center"
                style={{ flexShrink: 1, gap: "4px" }}
              >
                {person.nationality && <span>{person.nationality}</span>}
                {person.nationality && person.country && <span>,</span>}
                {person.country && <span>{person.country}</span>}
              </span>
              {person.country_flag && (
                <img
                  src={person.country_flag}
                  alt={person.country || "Flag"}
                  style={{
                    width: "22px",
                    height: "15px",
                    marginLeft: "6px",
                    borderRadius: "2px",
                    objectFit: "cover",
                    flexShrink: 0,
                  }}
                />
              )}
            </div>
          )}
        </div>
      </Col>

      {/* Form Fields - Stack vertically on mobile, horizontal on desktop */}
      <Col xs={12}>
        <Row className="g-3">
          {/* Skill - Full width on mobile, 4 columns on desktop */}
          <Col xs={12} lg={4} className="inter-font">
            <label className="inter-font fw-semibold mb-2" style={{ fontSize: "14px" }}>
              {t("t_d_text41")}<span className="text-danger">*</span>
            </label>
            <Select
              classNamePrefix="react-select"
              
              placeholder="Select"
              isDisabled = {true}
              value={
                person.category._id
                  ? { value: person.category._id, label: person.category.title }
                  : null
              }
              onChange={(selected) => handleCategoryChange(selected, index)}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                control: (base, state) => ({
                  ...base,
                  minHeight: "40px",
                  height: "40px",
                  borderRadius: "8px",
                  border: "1px solid #ced4da",
                  boxShadow: state.isFocused ? "0 0 0 1px #cd496d" : "none",
                  fontSize: "14px",
                  padding: "0 4px",
                }),
                valueContainer: (base) => ({ ...base, padding: "0 10px" }),
                placeholder: (base) => ({ ...base, color: "#6c757d", fontSize: "14px" }),
                option: (base, state) => ({
                  ...base,
                  padding: "8px 10px",
                  backgroundColor: state.isFocused ? "rgba(65,19,24,0.08)" : "white",
                  color: "#212529",
                  cursor: "pointer",
                }),
                singleValue: (base) => ({ ...base, fontSize: "14px", color: "#212529" }),
              }}
            />
            {errors.talentErrors?.[index]?.category && (
              <div style={{ color: "red", fontSize: "12px", marginTop: "2px" }}>
                {errors.talentErrors[index].category}
              </div>
            )}
          </Col>

          {/* Sub Skills - Full width on mobile, 4 columns on desktop */}
          <Col xs={12} lg={4} className="inter-font">
            <label className="inter-font fw-semibold mb-2" style={{ fontSize: "14px" }}>
              {t("t_d_text42")}
            </label>
            <Select
              classNamePrefix="react-select"
              options={person.availableSubSkills || []}
              placeholder={
                person.category._id 
                  ?  `${t("t_d_text43")} `
                  : "Select skill first"
              }
              value={
                person.sub_skill._id
                  ? {
                      value: person.sub_skill._id,
                      label:
                        i18n.language === "ar"
                          ? person.sub_skill.title_ar || person.sub_skill.title
                          : person.sub_skill.title,
                    }
                  : null
              }
              onChange={(selected) => handleSubSkillChange(selected, index)}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                control: (base, state) => ({
                  ...base,
                  minHeight: "40px",
                  height: "40px",
                  borderRadius: "8px",
                  border: "1px solid #ced4da",
                  boxShadow: state.isFocused ? "0 0 0 1px #cd496d" : "none",
                  fontSize: "14px",
                  padding: "0 4px",
                }),
                valueContainer: (base) => ({ ...base, padding: "0 10px" }),
                placeholder: (base) => ({ ...base, color: "#6c757d", fontSize: "14px" }),
                option: (base, state) => ({
                  ...base,
                  padding: "8px 10px",
                  backgroundColor: state.isFocused ? "rgba(65,19,24,0.08)" : "white",
                  color: "#212529",
                  cursor: "pointer",
                }),
                singleValue: (base) => ({ ...base, fontSize: "14px", color: "#212529" }),
              }}
              isDisabled={!person.category._id}
            />
          </Col>

          {/* Job Type & Hours - 2 columns on mobile, 3 columns on desktop */}
          <Col xs={6} lg={2} className="inter-font">
            <label className="inter-font fw-semibold mb-2" style={{ fontSize: "14px" }}>
               {t("t_d_text80")}<span className="text-danger">*</span>
            </label>
            <Form.Select
              value={person.job_type}
              onChange={(e) => {
                const jobType = e.target.value;
                const hours =
                  jobType === "full-time" ? "8" : jobType === "part-time" ? "4" : "";
                handleChange(index, "job_type", jobType);
                handleChange(index, "hours", hours);
              }}
              style={{
                height: "40px",
                fontSize: "14px",
                borderRadius: "8px",
                padding: "0 10px",
                border: "1px solid #ced4da",
      }}
 className={isRTL ? 'rtl-select' : ''}            >
                <option value="">{t('contractType.placeholder')}</option>
  <option value="full-time">{t('contractType.fullTime')}</option>
  <option value="part-time">{t('contractType.partTime')}</option>
            </Form.Select>
            {errors.talentErrors?.[index]?.job_type && (
              <div style={{ color: "red", fontSize: "12px", marginTop: "2px" }}>
                {errors.talentErrors[index].job_type}
              </div>
            )}
          </Col>

          <Col xs={6} lg={1} className="inter-font">
            <label className="inter-font fw-semibold mb-2" style={{ fontSize: "14px" }}>
              {t("c_t_text4")}
            </label>
            <Form.Control
              type="text"
              value={person.hours || ""}
              readOnly
              disabled
              style={{
                height: "40px",
                textAlign: "center",
                padding: "0",
                borderRadius: "8px",
                fontSize: "14px",
                border: "1px solid #ced4da",
                backgroundColor: "#f8f9fa",
              }}
            />
          </Col>

          {/* Date Slot & Days - Full width on mobile, 5 columns on desktop */}
          <Col xs={12} lg={4} className="inter-font">
            <label className="inter-font fw-semibold mb-2" style={{ fontSize: "14px" }}>
              {t("c_ff_text87")}<span className="text-danger">*</span>
            </label>
            <div
              id={`date-picker-container-${index}`}
              className="single-calendar-picker"
              style={{ position: "relative" }}
            >
              <DateRangePicker
                initialSettings={{
                  minDate: moment().startOf("day"),
                  parentEl: `#date-picker-container-${index}`,
                  linkedCalendars: false,
                }}
                onApply={(e, picker) => handleApply(e, picker, index)}
                autoUpdateInput={false}
                opens="right"
                drops="down"
              >
                <Form.Control
                  type="text"
                  placeholder={t("c_ff_text88")}
                  value={
                    person.start_date && person.end_date
                      ? `${formatShortDate(person.start_date)} - ${formatShortDate(person.end_date)}`
                      : ""
                  }
                  readOnly
                  style={{
                    height: "40px",
                    fontSize: "14px",
                    borderRadius: "8px",
                    padding: "0 10px",
                    border: "1px solid #ced4da",
                  }}
                />
              </DateRangePicker>
              {errors.talentErrors?.[index]?.dateSlot && (
                <div style={{ color: "red", fontSize: "12px", marginTop: "2px" }}>
                  {errors.talentErrors[index].dateSlot}
                </div>
              )}
            </div>
          </Col>

          <Col xs={12} lg={1} className="inter-font">
            <label className="inter-font fw-semibold mb-2" style={{ fontSize: "14px" }}>
              {t("c_t_text3")}
            </label>
            <Form.Control
              type="text"
              value={calculateDuration(person?.start_date, person?.end_date)}
              disabled
              style={{
                height: "40px",
                textAlign: "center",
                padding: "0",
                borderRadius: "8px",
                fontSize: "14px",
                border: "1px solid #ced4da",
                backgroundColor: "#f8f9fa",
              }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  ))}
</div>

          <div className="inter-font row mb-4">
          
          </div>
        
          <button
            className="inter-font fw-bold mt-2"
            style={{
              background: "#FF6B35",
              color: "#fff",
              border: "none",
              borderRadius: 12,
              fontSize: 20,
              padding: "14px 40px",
              minWidth: 160,
            }}
            type="button"
            onClick={handleSaveAndProceed}
            disabled={isLoadingCreateQuotes}
          >
            {isLoadingCreateQuotes ? `${t("c_ff_text61")}` : `${t("new_text_47")}`}
          </button>
        </form>
      </div>
    </div>
  );
};

// Add Back button to steps 2, 3, 4
const ProjectSummaryScreen = ({
  formData,
  onNext,
  onBack,
  selectedTalents = [],
  selectedTalentsUpdatedData,
  isSubmitting
}) => {
  const { t, i18n } = useTranslation();

  const calculateTotalPrice = () => {
    let total = 0;
    console.log(selectedTalentsUpdatedData);
    selectedTalentsUpdatedData.forEach((talent) => {
      const perDayRate = Number(talent.per_day_rate) || 0;
      const commissionRate = Number(talent.category?.commission_rate) || 0;
      
      if (talent.start_date && talent.end_date) {
        const startDate = new Date(talent.start_date);
        const endDate = new Date(talent.end_date);
        const diffTime = endDate - startDate;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
        console.log(diffDays);
        
        let rate = perDayRate;
        if (talent.job_type === 'part-time' || talent.job_type === 'Part Time') {
          rate = rate / 2;
        }
        
        const baseAmount = rate * diffDays;
        const commissionAmount = (baseAmount * commissionRate) / 100;
        total += baseAmount + commissionAmount;
      }
    });
    return total.toFixed(2);
  };

  const formatShortDate = (dateString) => {
    if (!dateString) return "";
  
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
  
    return `${day}-${month}-${year}`;
  };
         const isRTL = i18n.language === 'ar';

  return (
    <div
      className="inter-font d-flex justify-content-center"
      style={{
        paddingTop: 40,
        paddingBottom: 120,
        boxSizing: "border-box",
      }}
    >
      <div
        className="inter-font bg-white rounded-4 shadow p-3 p-md-5 position-relative"
        style={{  maxWidth: "100%" }}
      >
        {/* Selected Talents List (inside card) */}
        {/* {selectedTalents.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
            {selectedTalents.map((t) => (
              <div
                key={t._id}
                className="inter-font d-flex align-items-center bg-light rounded-3 px-3 py-2"
                style={{
                  background: "#F8F3F0",
                  minWidth: 200,
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <div className="inter-font d-flex align-items-center">
                  <img
                    src={dashboardTalent2}
                    alt="profile"
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 8,
                      marginRight: 12,
                    }}
                  />
                  <div>
                    <div className="inter-font fw-bold" style={{ fontSize: 18 }}>
                      {t.first_name} {t.last_name}
                    </div>
                    <div style={{ fontSize: 14, color: "#7A7A7A" }}>
                      {t.education}
                    </div>
                  </div>
                </div>
                <button
                  className="inter-font btn ms-3"
                  style={{
                    background: "#4B2E2B",
                    color: "#fff",
                    borderRadius: 14,
                    fontWeight: 500,
                    fontSize: 16,
                    padding: "10px 24px",
                  }}
                >
                  <LiaDownloadSolid style={{ marginRight: 8, fontSize: 20 }} />{" "}
                  Download Profile
                </button>
              </div>
            ))}
          </div>
        </div>
      )} */}
        {/* Project Info */}
        <div className="inter-font mb-3 fw-semibold" style={{ fontSize: 20 }}>
          {t("t_d_text95")}
        </div>
        <div
          className="inter-font text-secondary mb-4"
          style={{ fontSize: 15 }}
        >
          {selectedTalentsUpdatedData[0]?.title || (
            <span style={{ color: "#ccc" }}>
             {t("new_text_46")}
            </span>
          )}
        </div>
        <div className="inter-font mb-3 fw-semibold" style={{ fontSize: 20 }}>
          {t("c_t_s1_setp1")}
        </div>
        <div
          className="inter-font text-secondary mb-4"
          style={{ fontSize: 15 }}
        >
          {selectedTalentsUpdatedData[0]?.description || (
            <span style={{ color: "#ccc" }}>
              {t("new_text_46")}
            </span>
          )}
        </div>

        {/* Price Estimation Card */}
        <div className="inter-font bg-white rounded-3 p-3 p-md-4 shadow mb-4">
          <h5 className="inter-font fw-bold mb-3">Price Estimation</h5>
          <div className="d-flex justify-content-between align-items-center">
            <span className="text-secondary">Total Price Company Need to Pay:</span>
            <span className="fw-bold" style={{ fontSize: "1.2rem", color: "#FF6B35" }}>
              AED {calculateTotalPrice()}
            </span>
          </div>
        </div>

        {/* Details Row */}
         <div className="inter-font bg-white rounded-3 p-3 p-md-4 shadow">
          {selectedTalentsUpdatedData?.map((item, index) => (
            <Row
              key={item._id || index}
              className="inter-font mb-4 pb-3"
              style={{ borderBottom: "1px solid #eee" }}
            >
              {/* Talent Info - Full width on mobile */}
              <Col xs={12} className="inter-font d-flex align-items-center mb-3 gap-3">
                <Image
                  src={item?.picture}
                  alt="logo"
                  className="rounded-circle"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "cover",
                    border: "2px solid #ddd",
                  }}
                />

                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                  <h5 className="inter-font mb-1 fw-bold" style={{ fontSize: "16px" }}>
                    {item.first_name} {item.last_name}
                  </h5>
                  {(item.nationality || item.country) && (
                    <div
                      className={`text-muted d-flex align-items-center ${isRTL ? 'flex-row-reverse justify-content-end ' : ''}`}
                      style={{
                        flexWrap: "nowrap",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <img
                        src={LocationDot}
                        alt="Location Icon"
                        style={{
                          width: "15px",
                          height: "19px",
                          flexShrink: 0,
                          marginRight: "6px",
                        }}
                      />
                      <span
                        className="d-flex align-items-center"
                        style={{ flexShrink: 1, gap: "4px" }}
                      >
                        {item.nationality && <span>{item.nationality}</span>}
                        {item.nationality && item.country && <span>,</span>}
                        {item.country && <span>{item.country}</span>}
                      </span>
                      {item.country_flag && (
                        <img
                          src={item.country_flag}
                          alt={item.country || "Flag"}
                          style={{
                            width: "22px",
                            height: "15px",
                            marginLeft: "6px",
                            borderRadius: "2px",
                            objectFit: "cover",
                            flexShrink: 0,
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
              </Col>

              {/* Details Grid - Stack on mobile, row on desktop */}
              <Col xs={12}>
                <Row className="g-3">
                  {/* Days - 6 columns on mobile, 2 on desktop */}
                  <Col xs={6} lg={2} className="inter-font">
                    <div
                      className="inter-font fw-semibold text-secondary mb-1"
                      style={{ fontSize: "14px" }}
                    >
                      {t("c_t_text3")}
                    </div>
                    <div style={{ color: "#111", fontWeight: 500, fontSize: "14px" }}>
                      {item.duration || "-"}
                    </div>
                  </Col>

                  {/* Hours - 6 columns on mobile, 2 on desktop */}
                  <Col xs={6} lg={2} className="inter-font">
                    <div
                      className="inter-font fw-semibold text-secondary mb-1"
                      style={{ fontSize: "14px" }}
                    >
                      {t("c_t_text4")}
                    </div>
                    <div style={{ color: "#111", fontWeight: 500, fontSize: "14px" }}>
                      {item.hours || item.estimated_hours || "-"}
                    </div>
                  </Col>

                  {/* Job Type - 6 columns on mobile, 2 on desktop */}
                  <Col xs={6} lg={2} className="inter-font">
                    <div
                      className="inter-font fw-semibold text-secondary mb-1"
                      style={{ fontSize: "14px" }}
                    >
                     {t("t_d_text80")}
                    </div>
                    <div style={{ color: "#111", fontWeight: 500, fontSize: "14px" }}>
                      {item.job_type ? item.job_type.charAt(0).toUpperCase() + item.job_type.slice(1).replace('-', ' ') : "-"}
                    </div>
                  </Col>

                  {/* Skill - 6 columns on mobile, 2 on desktop */}
                  <Col xs={6} lg={2} className="inter-font">
                    <div
                      className="inter-font fw-semibold text-secondary mb-1"
                      style={{ fontSize: "14px" }}
                    >
                      {t("t_d_text41")}
                    </div>
                    <div style={{ color: "#111", fontWeight: 500, fontSize: "14px" }}>
                      {item.category && item.category.title ? item.category.title : "-"}
                    </div>
                  </Col>

                  {/* Sub Skill - 6 columns on mobile, 2 on desktop */}
                  <Col xs={6} lg={2} className="inter-font">
                    <div
                      className="inter-font fw-semibold text-secondary mb-1"
                      style={{ fontSize: "14px" }}
                    >
                      {t("t_d_text42")}
                    </div>
                    <div style={{ color: "#111", fontWeight: 500, fontSize: "14px" }}>
                      {item.sub_skill && item.sub_skill.title ? item.sub_skill.title : "-"}
                    </div>
                  </Col>

                  {/* Date Slot - 6 columns on mobile, 2 on desktop */}
                  <Col xs={6} lg={2} className="inter-font">
                    <div
                      className="inter-font fw-semibold text-secondary mb-1"
                      style={{ fontSize: "14px" }}
                    >
                       {t("c_t_text7")}
                    </div>
                    <div style={{ color: "#111", fontWeight: 500, fontSize: "14px",  direction: "ltr", 
    unicodeBidi: "plaintext"  }}>
                      {item.start_date && item.end_date 
                        ? `${formatShortDate(item.start_date)} - ${formatShortDate(item.end_date)}`
                        : "-"
                      }
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          ))}
        </div>
        <div className="inter-font d-flex justify-content-between mt-4">
          <button
            className="inter-font btn"
            style={{
              background: "#FF6B35",
              color: "#fff",
              border: "none",
              borderRadius: 12,
              fontWeight: 600,
              fontSize: 18,
              padding: "12px 36px",
            }}
            onClick={onNext}
            disabled={isSubmitting}
          >
            {isSubmitting ? t("c_ff_text61") : t("new_text_1")}
          </button>
        </div>
      </div>
    </div>
  );
};

const StatusScreen = ({
  formData,
  onBack,
  onViewQuote,
  selectedTalents = [],
}) => {
  const { t, i18n } = useTranslation();
  
  return(
  <div
    className="inter-font d-flex justify-content-center"
    style={{
      paddingTop: 40,
      paddingBottom: 120,
      boxSizing: "border-box",
    }}
  >
    <div
      className="inter-font bg-white rounded-4 shadow p-5 position-relative"
      style={{ width: 700, maxWidth: "100%" }}
    >
      {/* Selected Talents List (inside card) */}
      {selectedTalents.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
            {selectedTalents.map((t) => (
              <div
                key={t._id}
                className="inter-font d-flex align-items-center bg-light rounded-3 px-3 py-2"
                style={{
                  background: "#F8F3F0",
                  minWidth: 200,
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <div className="inter-font d-flex align-items-center">
                  <img
                    src={dashboardTalent2}
                    alt="profile"
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 8,
                      marginRight: 12,
                    }}
                  />
                  <div>
                    <div
                      className="inter-font fw-bold"
                      style={{ fontSize: 18 }}
                    >
                      {t.first_name} {t.last_name}
                    </div>
                    <div style={{ fontSize: 14, color: "#7A7A7A" }}>
                      {t.education}
                    </div>
                  </div>
                </div>
                <button
                  className="inter-font btn ms-3"
                  style={{
                    background: "#4B2E2B",
                    color: "#fff",
                    borderRadius: 14,
                    fontWeight: 500,
                    fontSize: 16,
                    padding: "10px 24px",
                  }}
                >
                  <LiaDownloadSolid style={{ marginRight: 8, fontSize: 20 }} />{" "}
                  Download Profile
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* Project Info */}
      <div className="inter-font mb-3 fw-semibold" style={{ fontSize: 20 }}>
        {t("c_t_s1_setp1")}
      </div>
      <div className="inter-font text-secondary mb-4" style={{ fontSize: 15 }}>
        {formData.projectInfo || (
          <span style={{ color: "#ccc" }}>
            No project information provided.
          </span>
        )}
      </div>
      {/* Details Row */}
      <div className="inter-font row mb-4" style={{ fontSize: 16 }}>
        <div className="inter-font col">
          <div
            className="inter-font fw-semibold text-secondary"
            style={{ fontSize: 15 }}
          >
            Required Duration
          </div>
          <div style={{ color: "#111", fontWeight: 500 }}>
            {formData.duration || "-"}
          </div>
        </div>
        <div className="inter-font col">
          <div
            className="inter-font fw-semibold text-secondary"
            style={{ fontSize: 15 }}
          >
            {t("t_d_text80")}
          </div>
          <div style={{ color: "#111", fontWeight: 500 }}>
            {formData.jobType || "-"}
          </div>
        </div>
        <div className="inter-font col">
          <div
            className="inter-font fw-semibold text-secondary"
            style={{ fontSize: 15 }}
          >
            Date Slot
          </div>
          <div style={{ color: "#111", fontWeight: 500 }}>
            {formData.dateSlot || "-"}
          </div>
        </div>
      </div>
      {/* Status Row */}
      <div className="inter-font row mb-4" style={{ fontSize: 16 }}>
        <div className="inter-font col">
          <div
            className="inter-font fw-semibold text-secondary"
            style={{ fontSize: 15 }}
          >
            Status
          </div>
          <div style={{ color: "#111", fontWeight: 500 }}>Quoted</div>
        </div>
        <div className="inter-font col d-flex justify-content-end align-items-end">
          <button
            className="inter-font btn"
            style={{
              background: "#85712B",
              color: "white",
              border: "none",
              borderRadius: 8,
              fontWeight: 600,
              fontSize: 18,
              padding: "12px 36px",
            }}
            onClick={onViewQuote}
          >
            View Quote
          </button>
        </div>
      </div>
    </div>
  </div>
)};

const HireTheTalent = () => {
  const navigate = useNavigate();
  const { profileData } = useUser();

  useEffect(() => {
    if (profileData && profileData.approval_status !== "Approved") {
      navigate("/company/talents");
    }
  }, [profileData, navigate]);

  const [step, setStep] = React.useState(1);
  const [formData, setFormData] = React.useState({
    projectInfo: "",
    projectAttachment: null,
    duration: "",
    jobType: "",
    dateSlot: "",
    startDate: new Date(),
    endDate: (() => {
      const date = new Date();
      date.setDate(date.getDate() + 7);
      return date;
    })(),
    projectId: "demoProjectId", // For viewQuote
  });
  const [errors, setErrors] = React.useState({});
  const { durationOptions, jobTypeOptions } = useFormOptions();
  const location = useLocation();
  const selectedTalentData = location.state?.selectedTalentData || [];
  console.log(selectedTalentData, "Select talents-----");
  const [showPopup, setShowPopup] = useState(false);
  const { t, i18n } = useTranslation();
  const [selectedTalentsUpdatedData, setSelectedTalentsUpdatedData] = useState(
    []
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCreateQuotes = async (data) => {
    try {
      setIsSubmitting(true);
      const res = await ApiService.request({
        method: "POST",
        url: `company/postProject`,
        data
      });

      if (res.data.status) {
        // setCreateJobData(false);
        // await fetchJobData(1);
        toast.success(res.data.message);
        setShowPopup(true);
        return res.data;
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.error("Edit Error:", err);
      toast.error("Failed to update job.");
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleSubmitData = async () => {
    try {
      if (
        !selectedTalentsUpdatedData ||
        selectedTalentsUpdatedData.length === 0
      ) {
        console.error("No data to submit");
        return;
      }

      // Prepare data for API (without spreading the person object)
      const apiData = selectedTalentsUpdatedData.map((person) => ({
        job_type: person.job_type,
        duration: `${person.duration} Days`,
        start_date: person.start_date,
        skill_id: person.category?._id || person.skill_id,
        sub_skill_id: person.sub_skill?._id || person.sub_skill_id,
        end_date: person.end_date,
        talent_id: person.talent_id,
        hours: `${person.hours} hours`,
      //  job_category: person.category._id || "",
        }));
        const payload = {
          title: selectedTalentsUpdatedData[0]?.title,
          description: selectedTalentsUpdatedData[0]?.description,
          projects: apiData
        };

        console.log("Final payload: ", payload);
        const resData = await handleCreateQuotes(payload);

      if (resData?.status) {
        // Handle successful submission
        console.log("Data submitted successfully");
        // You might want to navigate to another page here or show success message
      } else {
        console.error("Submission failed", resData);
      }
    } catch (error) {
      console.error("Error in handleSubmitData:", error);
      // Handle any errors that might occur during submission
    }
  };

  const validateStep1 = () => {
    const newErrors = {};
    if (!formData.projectInfo.trim()) {
      newErrors.projectInfo = "Required.";
    }
    if (!formData.duration) {
      newErrors.duration = "Duration is required.";
    }
    if (!formData.jobType) {
      newErrors.jobType = "Contract type is required.";
    }
    // if (!formData.startDate) {
    //   newErrors.startDate = "Date slot is required.";
    // }
    return newErrors;
  };
  const onClose = () => {
    navigate("/company/talents");
    setShowPopup(false);
  };

  return (
    <div className="inter-font main-bg" style={{ minHeight: "100vh", display: "flex", justifyContent: "center" }}>
      {/* <div className="inter-font container-fluid"> */}
      <div
        className="inter-font row"
        style={{
          height: "100vh",
          overflow: "auto",
          width: "100%",
          justifyContent: "center",
        }}
      >
        {/* <div className="inter-font col-md-2 p-0">
            <Sidebar activeTab={"talents"} setActiveTab={() => {}} />
          </div> */}
        <div
          className="inter-font col-md-10 content md:px-4 py-3"
          style={{
            height: "100vh",
            width: "100%",
            overflowY: "scroll",
            overflowX: "hidden",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent:"center"
          }}
        >
          {/* <Navbar /> */}
          {/* Stepper */}
          <HorizontalStepper step={step} setStep={setStep} />
          {step === 1 && (
            <>
              <ProjectInfoScreen
                formData={formData}
                setFormData={setFormData}
                errors={errors}
                setErrors={setErrors}
                onNext={async () => {
                  setStep(2);
                  // const validationErrors = validateStep1();
                  // if (Object.keys(validationErrors).length > 0) {
                  //   setErrors(validationErrors);
                  // } else {
                  //   setErrors({});
                  //   const ok = await postFormData(formData);
                  //   if (ok) setStep(2);
                  // }
                }}
                durationOptions={durationOptions}
                jobTypeOptions={jobTypeOptions}
                selectedTalents={selectedTalentData}
                selectedTalentData={selectedTalentData}
                setSelectedTalentsUpdatedData={setSelectedTalentsUpdatedData}
              />
            </>
          )}
          {step === 2 && (
            <>
              <ProjectSummaryScreen
                formData={formData}
                setFormData={setFormData}
                onNext={async () => {
                  // const ok = await requestQuote(formData);
                  // if (ok) setStep(3);
                  // navigate("/company/talents");
                  handleSubmitData();
                }}
                onBack={() => navigate("/company-dashboard?tab=talents")}
                selectedTalents={selectedTalentData}
                selectedTalentsUpdatedData={selectedTalentsUpdatedData}
                isSubmitting={isSubmitting}
              />

              {showPopup && (
                <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25 " style={{zIndex:"1000"}}>
                  <div
                    className="bg-white text-center p-4 rounded-4 shadow"
                    style={{
                      maxWidth: 500,
                      width: "90%",
                      boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div className="mb-3">
                      <div
                        className="mx-auto d-flex justify-content-center align-items-center"
                        style={{
                          backgroundColor: "#32C769",
                          width: 60,
                          height: 60,
                          borderRadius: "50%",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          fill="white"
                          className="bi bi-check-lg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.485 1.929a.75.75 0 0 1 1.03 1.092l-8 9a.75.75 0 0 1-1.08.02l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 7.52-8.522z" />
                        </svg>
                      </div>
                    </div>
                    <h5 className="fw-bold mb-2">{t("c_t_text8")}</h5>
                    <p className="text-secondary mb-4" style={{ fontSize: 14 }}>
                      {t("c_t_text9")}
                    </p>
                    <button
                      className="border-0 text-white fw-medium px-5 py-2"
                      style={{
                        backgroundColor: "#FF5C35",
                        borderRadius: "999px",
                        fontSize: 16,
                      }}
                      onClick={onClose}
                    >
                      {t("c_t_close")}
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
          {step === 3 && (
            <StatusScreen
              formData={formData}
              setFormData={setFormData}
              onBack={() => setStep(2)}
              onViewQuote={async () => {
                await viewQuote(formData);
              }}
              selectedTalents={selectedTalentData}
            />
          )}
          {/* Footer */}
          {/* <div>
              <DashboardFooter />
            </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default HireTheTalent;
